import Login from '@/components/auth/login';
import { getSession } from 'next-auth/react';

function LoginPage() {
  return <Login />;
}

export default LoginPage;

export async function getServerSideProps(context: any) {
  const session = await getSession({ req: context.req });
  if (!session) {
    return {
      props: { session },
    };
  }
  return {
    redirect: {
      destination: '/profile',
      permanent: false,
    },
  };
}
